import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="event-links"
//
// Client-side count cap for the custom-links card. Rows are added/removed by
// cocoon (jQuery events, not Stimulus), so we watch the list with a
// MutationObserver: when the number of live rows hits the max, hide the "Add
// link" control and show the localized max message. The server-side validation
// (Event#event_links_within_limit) remains the real guard.
export default class extends Controller {
  static targets = ["list", "addWrap", "maxMsg"]
  static values = { max: Number }

  connect() {
    this.observer = new MutationObserver(() => this.refresh())
    // Cocoon removes NEW rows from the DOM but hides PERSISTED ones
    // (display:none + _destroy flag) — watch both childList and style.
    this.observer.observe(this.listTarget, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style"],
    })
    this.refresh()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  refresh() {
    const atMax = this.liveRowCount() >= (this.maxValue || Infinity)
    if (this.hasAddWrapTarget) this.addWrapTarget.classList.toggle("d-none", atMax)
    if (this.hasMaxMsgTarget) this.maxMsgTarget.classList.toggle("d-none", !atMax)
  }

  liveRowCount() {
    return [...this.listTarget.querySelectorAll(".nested-fields")]
      .filter((el) => el.style.display !== "none").length
  }
}
